import helpers, {lastPageYOffset} from '../helpers';

function openTeam() {
	if (helpers.$html.dataset.currentPage !== 'modal') {
		helpers.saveScrollPosition();
		helpers.$body.style.setProperty('top', `-${lastPageYOffset}px`);
		helpers.$html.classList.add('is-lock-scroll');

		helpers.$body.style.setProperty('padding-right', `${helpers.getScrollbarWidth()}px`);
	}

	document.querySelector('.footer-modal').classList.add('is-opened');
}

function closeTeam() {
	if (helpers.$html.dataset.currentPage !== 'modal') {
		helpers.$body.style.removeProperty('top');
		helpers.$html.classList.remove('is-lock-scroll');
		helpers.$body.style.removeProperty('padding-right');
		helpers.restoreScrollPosition();
	}

	document.querySelector('.footer-modal').classList.remove('is-opened');
}

function init() {
	document.querySelectorAll('.js-footer-modal-close').forEach((item) => {
		item.addEventListener('click', (e) => {
			e.preventDefault();

			closeTeam();
		}, false);
	});

	document.querySelectorAll('.footer-modal__scroller').forEach((item) => {
		item.addEventListener('click', (e) => {
			if (!e.target.nodeName === 'A') {
				e.preventDefault();
			}
			const container = e.currentTarget.querySelector('.footer-modal__content');

			if (e.target !== container && !container.contains(e.target)) {
				closeTeam();
			}
		}, false);
	});

	document.addEventListener('keyup', (e) => {
		if (document.querySelector('.footer-modal').classList.contains('is-opened') && e.key === 'Escape') {
			closeTeam();
		}
	});

	document.querySelector('.footer__team-button').addEventListener('click', openTeam, false);
}

export default {
	init,
};
